// src/utils/letterSemesters.ts
//
// Load letters are matched by staff + academic year + semester, so generating
// for a different semester than a year's existing letters creates a second,
// separate set instead of updating them (#286). These helpers let Generate
// Letters default to, and warn about, the semester already in use.

import { Semester } from '../types/loadLetter';

export const semesterLabel = (semester: Semester | string): string =>
  semester === 'semester1' ? 'Semester 1'
    : semester === 'semester2' ? 'Semester 2'
    : semester === 'both' ? 'Full Year'
    : semester;

/** Count of current letters per semester, most common first. */
export const lettersBySemester = (letters: { semester: Semester }[]): Array<{ semester: Semester; count: number }> => {
  const counts = new Map<Semester, number>();
  for (const l of letters) counts.set(l.semester, (counts.get(l.semester) ?? 0) + 1);
  return Array.from(counts, ([semester, count]) => ({ semester, count })).sort((a, b) => b.count - a.count);
};

/** The semester most of a year's letters use, or null if there are none. */
export const predominantSemester = (letters: { semester: Semester }[]): Semester | null =>
  lettersBySemester(letters)[0]?.semester ?? null;

/**
 * Existing letters in semesters OTHER than the one about to be generated.
 * Empty means generating will update (or add to) the letters already there.
 */
export const otherSemesterLetters = (
  letters: { semester: Semester }[],
  selected: Semester,
): Array<{ semester: Semester; count: number }> =>
  lettersBySemester(letters).filter(s => s.semester !== selected);
